module.exports = {"231084001":"城区街道","231084100":"宁安镇","231084101":"东京城镇","231084102":"渤海镇","231084103":"石岩镇","231084104":"沙兰镇","231084105":"海浪镇","231084106":"兰岗镇","231084107":"镜泊镇","231084202":"江南朝鲜族满族乡","231084206":"卧龙朝鲜族乡","231084208":"马河乡","231084211":"三陵乡","231084400":"东京城林业局","231084500":"宁安农场"}


//////////////////
// WEBPACK FOOTER
// ./src/town/231084.json
// module id = 879
// module chunks = 0